import { DependencyGroupDto, DependencyItemDto } from '@/services/dependencies';

export function legalDependency(o1: number, o2: number, dependencies: DependencyItemDto[]) {
    let not = dependencies.some((n) => (n.from === o1 && n.to === o2) || (n.from === o2 && n.to === o1));

    if (not) {
        return false;
    } else {
        return true;
    }

    // const from_o1 = dependencies.filter((x) => !x.isNegates).filter((d) => d.from === o1);
    // const from_o2 = dependencies.filter((x) => !x.isNegates).filter((d) => d.from === o2);

    // if (from_o1.length === 0 && from_o2.length === 0) {
    //     return true;
    // }

    // if (from_o1.some((d) => d.to === o2)) {
    //     return true;
    // }

    // if (from_o2.some((d) => d.to === o1)) {
    //     return true;
    // }

    // return false;
}
interface Selection {
    linkGroupId: number;
    selectedLinkGroupItemId: number;
}

export interface DependencyError {
    fromItemId: number;
    toItemId: number;
    dependency: DependencyGroupDto;
}

export function checkIfLegalDep(listOfSelections: Selection[], dependencies: DependencyGroupDto[]) {
    let errors: DependencyError[] = [];
    dependencies.forEach((d) => {
        let from = listOfSelections.find((x) => x.linkGroupId === d.fromOptionGroupId);
        let to = listOfSelections.find((x) => x.linkGroupId === d.toOptionGroupId);

        if (from && to) {
            let legal = legalDependency(from.selectedLinkGroupItemId, to.selectedLinkGroupItemId, d.dependencyItems);
            if (!legal) {
                errors.push({
                    fromItemId: from.selectedLinkGroupItemId,
                    toItemId: to.selectedLinkGroupItemId,
                    dependency: d,
                });
            }
        }
    });
    return errors;
}

